import { Window } from './interfaces';

interface EventActionAndLabel {
  eventAction: string;
  eventLabel: string;
}

export interface GoogleTrackingEvent extends EventActionAndLabel {
  event: string;
  eventCategory: string;
}

const RegEventCategory = 'registration';

enum EventAction {
  registration = 'registration',
  login = 'login',
  click = 'click',
  error = 'error',
}

export class GoogleTracking {
  eventTriggerName: string;
  eventCategory: string;

  constructor(eventTriggerName: string, eventCategory: string) {
    this.eventCategory = eventCategory;
    this.eventTriggerName = eventTriggerName;
  }
  trackEvent = ({ eventAction, eventLabel }: EventActionAndLabel) => {
    (window as Window).dataLayer?.push({
      event: this.eventTriggerName,
      eventCategory: this.eventCategory,
      eventAction,
      eventLabel,
    });
  };

  trackClickEvent(eventLabel: string) {
    this.trackEvent({ eventAction: EventAction.click, eventLabel });
  }

  trackErrorEvent(eventLabel: string) {
    this.trackEvent({ eventAction: EventAction.error, eventLabel });
  }
}

export class RegGoogleTracking extends GoogleTracking {
  constructor(eventTriggerName: string) {
    super(eventTriggerName, RegEventCategory);
  }

  trackLoginEvent(eventLabel: string) {
    this.trackEvent({ eventAction: EventAction.login, eventLabel });
  }

  trackRegisterEvent(eventLabel: string) {
    this.trackEvent({ eventAction: EventAction.registration, eventLabel });
  }

  trackSocialLogIn(
    socialSite: string,
    accountWasCreated?: boolean,
    accountWasLinked?: boolean
  ): void {
    if (accountWasCreated) {
      this.trackRegisterEvent(`join_now_${socialSite}`);

      return;
    }

    if (accountWasLinked) {
      this.trackLoginEvent(`link_${socialSite}`);

      return;
    }

    this.trackLoginEvent(`sign_in_${socialSite}`);
  }
}

export class NewRelicLogging {
  eventTriggerName: string;
  eventCategory: string;

  constructor(eventTriggerName: string, eventCategory: string) {
    this.eventCategory = eventCategory;
    this.eventTriggerName = eventTriggerName;
  }

  addPageAction = (
    actionName: string,
    attributes?: Record<string, unknown>
  ) => {
    (window as Window).newrelic?.addPageAction(actionName, attributes);
  };

  logErrorEvent = (
    eventLabel: string,
    attributes?: Record<string, unknown>
  ) => {
    (window as Window).newrelic?.addPageAction(this.eventTriggerName, {
      eventCategory: this.eventCategory,
      eventAction: EventAction.error,
      eventLabel,
      ...attributes,
    });
  };

  logClickEvent = (
    eventLabel: string,
    attributes?: Record<string, unknown>
  ) => {
    (window as Window).newrelic?.addPageAction(this.eventTriggerName, {
      eventCategory: this.eventCategory,
      eventAction: EventAction.click,
      eventLabel,
      ...attributes,
    });
  };
}

export class RegNewRelicLogging extends NewRelicLogging {
  constructor(eventTriggerName: string) {
    super(eventTriggerName, RegEventCategory);
  }

  logLoginEvent = (
    eventLabel: string,
    attributes?: Record<string, unknown>
  ) => {
    (window as Window).newrelic?.addPageAction(this.eventTriggerName, {
      eventCategory: this.eventCategory,
      eventAction: EventAction.login,
      eventLabel,
      ...attributes,
    });
  };

  logRegisterEvent = (
    eventLabel: string,
    attributes?: Record<string, unknown>
  ) => {
    (window as Window).newrelic?.addPageAction(this.eventTriggerName, {
      eventCategory: this.eventCategory,
      eventAction: EventAction.registration,
      eventLabel,
      ...attributes,
    });
  };

  logSocialLogIn(
    socialSite: string,
    accountWasCreated?: boolean,
    accountWasLinked?: boolean
  ): void {
    if (accountWasCreated) {
      this.logRegisterEvent(`join_now_${socialSite}`);

      return;
    }

    if (accountWasLinked) {
      this.logLoginEvent(`link_${socialSite}`);

      return;
    }

    this.logLoginEvent(`sign_in_${socialSite}`);
  }
}
